<template>
  <v-card class="mt-0" outlined :loading="loading">
    <v-card-title class="justify-center"> Billed Revenue (YTD) </v-card-title>
    <v-card-text>
      <template>
        <div>
          <vue-apex-charts
            type="area"
            :options="chartOptions"
            :series="series"
            :height="240"
          ></vue-apex-charts>
        </div>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import {
  startOfTomorrow,
  startOfMonth,
  subMonths,
  parseISO,
  format
} from "date-fns";
import { getBillingRevenueGraph } from "../../api/report";
import { formatDollarCents } from "../../common/format";

export default {
  name: "BilledRevenueGraph",

  components: { VueApexCharts },

  data() {
    return {
      loading: false,
      periods: [],
      series: []
    };
  },

  computed: {
    chartOptions() {
      const periods = this.periods;
      return {
        chart: {
          id: "vuechart-example",
          toolbar: {
            show: false
          },
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        legend: {
          show: true,
          showForSingleSeries: true
        },
        stroke: {
          curve: "straight"
        },
        tooltip: {
          enabled: true,
          shared: true
        },
        xaxis: {
          categories: periods
        },
        yaxis: {
          forceNiceScale: true,
          labels: {
            formatter: value => formatDollarCents(value)
          }
        }
      };
    }
  },

  mounted() {
    this.loadData();
  },

  methods: {
    async loadData(
      startDate = startOfMonth(subMonths(new Date(), 12)),
      endDate = startOfTomorrow()
    ) {
      try {
        this.loading = true;

        const result = await getBillingRevenueGraph(startDate, endDate);

        this.periods = result.items.map(item =>
          format(parseISO(item.date), "MMM")
        );
        this.series = [
          {
            name: "Total",
            data: result.items.map(item => item.total)
          },
          {
            name: "Premium Clicks",
            data: result.items.map(item => item.clicks)
          },
          {
            name: "Premium Calls",
            data: result.items.map(item => item.calls)
          },
          {
            name: "Monthly Upgrade Fees",
            data: result.items.map(item => item.subscriptions)
          }
        ];
      } catch (e) {
        console.error("ERROR IN BILLED REVENUE GRAPH", e);
      }

      this.loading = false;
    }
  }
};
</script>
